import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author PKr
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { DummyWindow } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { DummyWindowLayer } from "../../transportLayers/window/DummyWindowLayer";
/**
 * This store obtaining data of tiers.
 */

export var DummyWindowStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(DummyWindowStore, _BaseStore);

  function DummyWindowStore() {
    var _this;

    _classCallCheck(this, DummyWindowStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowStore).apply(this, arguments));
    _this.name = StoreName.DummyWindow;
    _this.dummyWindowLayer = new DummyWindowLayer();
    _this.list = new Map();
    return _this;
  }
  /**
   * Fletches all dummy windows
   * returns a promise with Map of items
   */


  _createClass(DummyWindowStore, [{
    key: "getAll",
    value: function getAll() {
      var _this2 = this;

      return this.dummyWindowLayer.findAllInfos().then(function (infos) {
        runInAction(function () {
          _this2.list.clear();

          infos.forEach(function (info) {
            _this2.list.set(info.dummyWindow.id, info.dummyWindow);
          });
        });
        return _this2.list;
      });
    }
    /**
     * Updates dummy window
     * Updates list on success
     * @param window - theme that you want to update
     */

  }, {
    key: "update",
    value: function update(window) {
      var _this3 = this;

      return this.dummyWindowLayer.update(window).then(function (updatedWindow) {
        runInAction(function () {
          _this3.list.set(updatedWindow.id, updatedWindow);
        });
        return _this3.list;
      });
    }
    /**
     * Creates new dummy window
     * Updates list on success
     * @param window - new theme that you want to create
     */

  }, {
    key: "create",
    value: function create(window) {
      var _this4 = this;

      return this.dummyWindowLayer.create(window).then(function (updatedWindow) {
        runInAction(function () {
          _this4.list.set(updatedWindow.id, updatedWindow);
        });
        return _this4.list;
      });
    }
    /**
     * Deletes dummy window
     * Updates list on success
     * @param id - id of the theme that you want to delete.
     */

  }, {
    key: "delete",
    value: function _delete(id) {
      var _this5 = this;

      return this.dummyWindowLayer.delete(id).then(function () {
        runInAction(function () {
          _this5.list.delete(id);
        });
        return _this5.list;
      });
    }
  }]);

  return DummyWindowStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], DummyWindowStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", Promise)], DummyWindowStore.prototype, "getAll", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [DummyWindow]), __metadata("design:returntype", Promise)], DummyWindowStore.prototype, "update", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [DummyWindow]), __metadata("design:returntype", Promise)], DummyWindowStore.prototype, "create", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], DummyWindowStore.prototype, "delete", null);